import { Flex, spaces } from '@electricjs/arc';

import { Store } from '@/types/storefront';
import { Product } from '@/types/products';
import { StorefrontAsset } from '@/types/assets';

import { ItemMiniListRow } from './ItemMiniListRow';

type CatalogMiniList = {
  store: Store.Catalog;
  items?: Product[];
  onAddItem: (item: Product) => void;
  onRemoveItem: (item: Product) => void;
};

type AssetMiniList = {
  store: Store.Asset;
  items?: StorefrontAsset[];
  onAddItem: (item: StorefrontAsset) => void;
  onRemoveItem: (item: StorefrontAsset) => void;
};

type ItemMiniListProps = (CatalogMiniList | AssetMiniList) & {
  id: string;
  selectedItemsIds: string[];
};

export const ItemMiniList = ({
  id,
  store,
  items,
  selectedItemsIds,
  onAddItem,
  onRemoveItem,
}: ItemMiniListProps) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Flex
      id={id}
      vertical
      rowGap={spaces.space_xs}
      height="100%"
      width="100%"
      overflow="auto">
      {items.map(item => {
        if (store === Store.Catalog) {
          const catalogItem = item as Product;

          return (
            <ItemMiniListRow
              key={item.id}
              id={`${id}-item-${item.id}`}
              store={store}
              item={catalogItem}
              selected={selectedItemsIds.includes(item.id)}
              onAddItem={() => onAddItem(catalogItem)}
              onRemoveItem={() => onRemoveItem(catalogItem)}
            />
          );
        } else if (store === Store.Asset) {
          const assetItem = item as StorefrontAsset;

          return (
            <ItemMiniListRow
              key={item.id}
              id={`${id}-item-${item.id}`}
              store={store}
              item={assetItem}
              selected={selectedItemsIds.includes(item.id)}
              onAddItem={() => onAddItem(assetItem)}
              onRemoveItem={() => onRemoveItem(assetItem)}
            />
          );
        }
      })}
    </Flex>
  );
};
